import { isPlainObject } from 'lodash';

type RequestFunType = (...arg:any) => Promise<any>;

function createTimerForApi(requestFun:RequestFunType) {
  return function (...rest:any) {
    const now = Date.now();
    return requestFun(...rest).then((data:any) => {
      const backNow = Date.now();
      // 单位：秒
      const result = ((backNow - now) / 1000).toFixed(3);
      if (isPlainObject(data)) {
        return {
          ...data,
          api_timer: result,
        };
      }
      return {
        data,
        api_timer: result,
      };
    });
  };
}

export {
  createTimerForApi,
};
export default {};
